import React from 'react'
import '../../assets/plugins/plugins.bundle.css'

function SFooter() {

  return (
    <>
        <div className='app-footer d-flex flex-column flex-md-row flex-center flex-md-stack pb-3'>
            <div className='text-dark order-2 order-md-1'>
                <span className='text-muted fw-semibold me-1'>2025&copy;</span>
            </div>
            <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'>
                <li className='menu-item'><span className='menu-link px-2'>About</span></li>
                <li className='menu-item'><span className='menu-link px-2'>Support</span></li>
            </ul>
        </div>
    </>
  )
}

export default SFooter